<div class="times-wrapper">
  <wchfs-time-list [timeType]="timeTypes?.HH" [value]="currentTime?.HH" (pickerValueChange)="pickerValueChange($event)">
  </wchfs-time-list>
  <div class="separator"></div>
  <wchfs-time-list [timeType]="timeTypes?.MM" [value]="currentTime?.MM" (pickerValueChange)="pickerValueChange($event)">
  </wchfs-time-list>
</div>
